/*eslint-disable */
define(function (require) {
    var moment = require('moment');
    var PageConfig = require('common/page-config');

    /**
     * Format a time from an HHMM number.
     *
     * For example twenty-two minute past three in the afternoon can be passed as:
     *     "1523"
     *     1523
     *
     * @param String|Number time   a time
     * @param String        format a momentjs format string
     */
    function fromHoursMinutes (time, format) {
        var locale = PageConfig.locale.locale || 'en_GB';

        if (typeof time !== 'number') {
            time = Number(time);
        }

        if (!format) {
            format = PageConfig.locale.timeFormat || 'h:mm a';
        }

        var hour = time / 100;
        var minute = time % 100;
        var m = moment().locale(locale).hour(hour).minute(minute);

        return m.format(format);
    }

    /**
     * Format a time from the number of minutes past midnight.
     *
     * @param Number  minutesPastMidnight  number of minutes past midnight
     * @param String  format               a momentjs format string
     */
    function fromMinutesPastMidnight (minutesPastMidnight, format) {
        var locale = PageConfig.locale.locale || 'en_GB';

        if (!format) {
            format = PageConfig.locale.dateTimeFormats['short-time'].javascriptMomentFormat || 'HH:mm';
        }

        // set moment locale
        moment.locale(locale);

        var hour = minutesPastMidnight / 60;
        var minute = minutesPastMidnight % 60;
        var m = moment().hour(hour).minute(minute);

        return m.format(format);
    }

    function dateObjectFromDateAndMinutesPastMidnight (date, minutesPastMidnight) {
        var locale = PageConfig.locale.locale || 'en_GB';

        // set moment locale
        moment.lang(locale);

        var hour = minutesPastMidnight / 60;
        var minute = minutesPastMidnight % 60;

        return moment(date).hour(hour).minute(minute);
    }

    return {
        fromHoursMinutes: fromHoursMinutes,
        fromMinutesPastMidnight: fromMinutesPastMidnight,
        dateObjectFromDateAndMinutesPastMidnight: dateObjectFromDateAndMinutesPastMidnight
    };
});
